import React, { useState } from 'react';

const Chatai: React.FC = () => {
  const [selectedModel, setSelectedModel] = useState<string>('GPT-4');
  const [questions, setQuestions] = useState<string[]>([]);
  const [currentQuestion, setCurrentQuestion] = useState<string>('');

  const handleSubmit = () => {
    if (currentQuestion.trim()) {
      setQuestions([currentQuestion, ...questions]);
      setCurrentQuestion('');
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col justify-center items-center p-4">
      <div className="w-full max-w-2xl mb-8">
        <h1 className="text-xl font-bold mb-4">Preguntas</h1>
        <ul className="bg-white rounded-lg shadow-lg p-4 mb-8 max-h-96 overflow-y-auto">
          {questions.map((question, index) => (
            <li key={index} className="mb-2 p-2 border-b border-gray-200 last:border-b-0">
              {question}
            </li>
          ))}
        </ul>
      </div>
      <div className="flex justify-center space-x-4 mb-8">
        <button
          className={`px-4 py-2 rounded-full ${
            selectedModel === 'GPT-4' ? 'bg-blue-600 text-white' : 'bg-gray-200'
          }`}
          onClick={() => setSelectedModel('GPT-4')}
        >
          GPT-4
        </button>
        <button
          className={`px-4 py-2 rounded-full ${
            selectedModel === 'GPT-3.5' ? 'bg-blue-600 text-white' : 'bg-gray-200'
          }`}
          onClick={() => setSelectedModel('GPT-3.5')}
        >
          GPT-3.5
        </button>
      </div>
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-2xl">
        <textarea
          className="w-full p-4 border border-gray-300 rounded-lg mb-4"
          rows={4} // Aquí aseguramos que el valor de rows sea un número
          placeholder="Escribe aqui tus preguna y duda sobre el uso de nuestra plataforma."
          value={currentQuestion}
          onChange={(e) => setCurrentQuestion(e.target.value)}
        ></textarea>
        <button
          className="bg-blue-500 text-white px-4 py-2 rounded-full w-full"
          onClick={handleSubmit}
        >
          Enviar Pregunta
        </button>
      </div>
      <p className="mt-4 text-gray-500 text-xs">
      ChatGPT puede cometer errores. Comprueba la información importante.
      </p>
    </div>
  );
};

export default Chatai;
